import Strategy from "../image/categoryImg/chess.png";
import Roll from "../image/categoryImg/sword.png";
import Card from "../image/categoryImg/poker.png";
import Team from "../image/categoryImg/handshake.png";
import Mystery from "../image/categoryImg/worker.png";
import Batting from "../image/categoryImg/gambling.png";
import Mafia from "../image/categoryImg/fedora.png";
import Memory from "../image/categoryImg/brain.png";
import Fast from "../image/categoryImg/hourglass.png";
import Etc from "../image/categoryImg/more.png";

export const CategoryMatch = [
  { id: 1, genre: "전략게임", icon: Strategy },
  { id: 2, genre: "롤플레잉", icon: Roll },
  { id: 3, genre: "카드게임", icon: Card },
  { id: 4, genre: "협력게임", icon: Team },
  { id: 5, genre: "추리게임", icon: Mystery },
  { id: 6, genre: "배팅게임", icon: Batting },
  { id: 7, genre: "마피아", icon: Mafia },
  { id: 8, genre: "기억력", icon: Memory },
  { id: 9, genre: "순발력", icon: Fast },
  { id: 10, genre: "기타게임", icon: Etc },
];
